import { Node } from '@tiptap/core'

// Dítě galerie = JEN <img>, atom, draggable přes ProseMirror
export const GalleryImage = Node.create({
  name: 'galleryImage',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,
  addAttributes() {
    return {
      src: { default: null },
      alt: { default: '' },
      class: { default: 'gallery-image-draggable ProseMirror-selectednode' },
    }
  },
  parseHTML() {
    return [{
      tag: 'img',
      // Parsuj všechny img tagy jako GalleryImage
      getAttrs: el => ({
        src: el.getAttribute('src') || null,
        alt: el.getAttribute('alt') || '',
        // Zachovej třídy při načítání
        class: el.getAttribute('class') || '',
      })
    }]
  },
  renderHTML({ HTMLAttributes }) {
    const { src, alt, class: className } = HTMLAttributes
    if (!src) return ['img']    // bezpečnost
    // Vždy přidej třídu pro konzistentní styling
    return ['img', { 
      src, 
      alt, 
      draggable: 'true',
      class: className || 'gallery-image-draggable ProseMirror-selectednode'
    }]
  },
  addNodeView() {
    return ({ node, getPos, editor }) => {
      console.log('GalleryImage NodeView created for:', node.attrs.src)
      const img = document.createElement('img')
      img.src = node.attrs.src || ''
      img.alt = node.attrs.alt || ''
      img.draggable = true
      img.className = 'gallery-image-draggable ProseMirror-selectednode'
      console.log('Image classes set:', img.className)
      
      // Ujisti se, že je img draggable i po re-renderu
      img.addEventListener('dragstart', (e) => {
        console.log('GalleryImage dragstart')
        if (typeof getPos === 'function') {
          const pos = getPos()
          // Nastav selection na tento node pro drag
          if (editor) {
            editor.view.dispatch(
              editor.state.tr.setSelection(
                editor.state.selection.constructor.near(
                  editor.state.doc.resolve(pos)
                )
              )
            )
          }
        }
      })
      
      return { dom: img }
    }
  },
})

export const Gallery = Node.create({
  name: 'gallery',
  group: 'block',
  content: 'galleryImage+',
  isolating: true,
  parseHTML() { 
    return [{
      tag: 'div.gallery',
      contentElement: '.gallery-content'
    }]
  },
  renderHTML() { return ['div', { class: 'gallery' }, ['div', { class: 'gallery-content' }, 0]] },
  addNodeView() {
    return ({ editor, getPos }) => {
      const dom = document.createElement('div')
      dom.className = 'gallery'
      const contentDOM = document.createElement('div')
      contentDOM.className = 'gallery-content'
      
      // Tlačítko + pro přidání obrázků
      const addButton = document.createElement('button')
      addButton.className = 'gallery-add-btn'
      addButton.innerHTML = '+'
      addButton.title = 'Přidat obrázky do galerie'
      addButton.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        console.log('Gallery + button clicked')
        
        // Najdi galerii (parent element)
        const gallery = addButton.closest('.gallery')
        if (!gallery) {
          console.log('Gallery not found')
          return
        }
        
        // Najdi pozici galerie v editoru
        const galleryPos = editor.view.posAtDOM(gallery, 0) - 1
        console.log('Gallery position:', galleryPos)
        
        // Zkus použít window.tiptapController
        if (window.tiptapController) {
          console.log('Found tiptap controller in window, calling showGalleryDialog with position:', galleryPos)
          // Předaj pozici galerie do showGalleryDialog
          window.tiptapController.showGalleryDialog(galleryPos)
        } else {
          console.log('Tiptap controller not found in window')
        }
      })
      
      // Tlačítko koše pro smazání galerie
      const deleteButton = document.createElement('button')
      deleteButton.className = 'gallery-delete-btn'
      deleteButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3,6 5,6 21,6"></polyline><path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>'
      deleteButton.title = 'Smazat galerii'
      deleteButton.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        console.log('Gallery delete button clicked')
        
        // Confirm dialog
        if (!confirm('Opravdu chcete smazat celou galerii?')) {
          return
        }
        
        // Najdi galerii (parent element)
        const gallery = deleteButton.closest('.gallery')
        if (!gallery) {
          console.log('Gallery not found')
          return
        }
        
        // Najdi pozici galerie v editoru
        const galleryPos = editor.view.posAtDOM(gallery, 0) - 1
        console.log('Gallery position to delete:', galleryPos)
        
        // Smazání galerie
        if (window.tiptapController) {
          console.log('Deleting gallery at position:', galleryPos)
          window.tiptapController.editor.chain().focus().setNodeSelection(galleryPos).deleteSelection().run()
        }
      })
      
      dom.appendChild(contentDOM)
      dom.appendChild(addButton)
      dom.appendChild(deleteButton)
      return { dom, contentDOM }
    }
  },
  addCommands() {
    return {
      insertGallery: (items = []) => ({ chain }) => {
        const content = items.filter(i => i?.src).map(i => ({
          type: 'galleryImage', attrs: { src: i.src, alt: i.alt || '' }
        }))
        if (!content.length) return false
        return chain().insertContent({ type: 'gallery', content }).run()
      },
      appendToGallery: (items = []) => ({ state, tr, dispatch }) => {
        console.log('appendToGallery called, selection:', state.selection)
        console.log('selection node:', state.selection?.node)
        console.log('selection node type:', state.selection?.node?.type?.name)
        
        // Najdi galerii v selection (buď je to node, nebo je kurzor uvnitř)
        let galleryNode = null
        let galleryPos = null
        
        if (state.selection?.node?.type.name === 'gallery') {
          // Selection je přímo na galerii
          galleryNode = state.selection.node
          galleryPos = state.selection.from
          console.log('Found gallery node directly')
        } else {
          // Hledej galerii v parents
          const $from = state.selection.$from
          for (let i = $from.depth; i >= 0; i--) {
            const node = $from.node(i)
            if (node.type.name === 'gallery') {
              galleryNode = node
              galleryPos = $from.start(i)
              break
            }
          }
        }
        
        if (!galleryNode) return false
        
        const list = items.filter(i => i?.src).map(i =>
          state.schema.nodes.galleryImage.create({ src: i.src, alt: i.alt || '' })
        )
        if (!list.length) return false
        
        // Vlož na konec galerie (před uzavírací tag)
        const insertPos = galleryPos + galleryNode.nodeSize - 1
        if (dispatch) dispatch(tr.insert(insertPos, list))
        return true
      },
      appendToGalleryAt: (items = [], position) => ({ state, tr, dispatch }) => {
        // Přidej obrázky do galerie na konkrétní pozici
        const node = state.doc.nodeAt(position)
        if (!node || node.type.name !== 'gallery') return false
        
        const list = items.filter(i => i?.src).map(i =>
          state.schema.nodes.galleryImage.create({ src: i.src, alt: i.alt || '' })
        )
        if (!list.length) return false
        
        // Vlož na konec galerie (před uzavírací tag)
        const insertPos = position + node.nodeSize - 1
        if (dispatch) dispatch(tr.insert(insertPos, list))
        return true
      },
    }
  },
})